import React from 'react';
import { Phone, User, Eye, EyeOff, Loader } from 'lucide-react';

export const PhoneStepForm = ({ vm }) => (
    <form onSubmit={vm.handleRequestOtp} className="space-y-6">
        <div>
            <label className="block text-gray-300 font-semibold mb-3">Phone Number</label>
            <div className="relative">
                <Phone className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input
                    type="tel"
                    value={vm.phone}
                    onChange={(e) => vm.setPhone(e.target.value)}
                    placeholder="9800000000"
                    className="w-full pl-12 pr-4 py-3 bg-white/10 border border-white/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-green-400 focus:ring-2 focus:ring-green-400/20 backdrop-blur-sm transition-all"
                    disabled={vm.loading}
                />
            </div>
            <p className="text-gray-400 text-xs mt-2">Enter 10-digit phone number (any Nepali telecom)</p>
        </div>

        <button
            type="submit"
            disabled={vm.loading || !vm.phone}
            className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white font-bold py-3 px-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-green-500/50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
            {vm.loading && <Loader className="w-4 h-4 animate-spin" />}
            Send OTP
        </button>
    </form>
);

export const PasswordLoginStepForm = ({ vm }) => (
    <form onSubmit={vm.handlePasswordLogin} className="space-y-6">
        <div>
            <label className="block text-gray-300 font-semibold mb-3">Phone Number</label>
            <div className="relative">
                <Phone className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input
                    type="tel"
                    value={vm.phone}
                    onChange={(e) => vm.setPhone(e.target.value)}
                    placeholder="9800000000"
                    className="w-full pl-12 pr-4 py-3 bg-white/10 border-2 border-white/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-500/30 backdrop-blur-sm transition-all"
                    style={{
                        WebkitAutofillBoxShadow: '0 0 0 1000px rgba(255, 255, 255, 0.1) inset',
                        WebkitAutofillTextFillColor: '#ffffff',
                        WebkitTextFillColor: '#ffffff',
                    }}
                    disabled={vm.loading}
                />
            </div>
            <p className="text-gray-400 text-xs mt-2">Enter 10-digit phone number</p>
        </div>

        <div>
            <label className="block text-gray-300 font-semibold mb-3">Password</label>
            <div className="relative">
                <input
                    type={vm.showPassword ? 'text' : 'password'}
                    value={vm.password}
                    onChange={(e) => vm.setPassword(e.target.value)}
                    placeholder="Enter your password"
                    className="w-full px-4 py-3 pr-12 bg-white/10 border-2 border-white/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-500/30 backdrop-blur-sm transition-all autofill:bg-white/10 autofill:text-white autofill:shadow-none"
                    style={{
                        WebkitAutofillBoxShadow: '0 0 0 1000px rgba(255, 255, 255, 0.1) inset',
                        WebkitAutofillTextFillColor: '#ffffff',
                        WebkitTextFillColor: '#ffffff',
                    }}
                    disabled={vm.loading}
                />
                <button
                    type="button"
                    onClick={() => vm.setShowPassword(!vm.showPassword)}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-300 transition-colors"
                    disabled={vm.loading}
                >
                    {vm.showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
            </div>
        </div>

        <button
            type="submit"
            disabled={vm.loading || !vm.phone || !vm.password}
            className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white font-bold py-3 px-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-green-500/50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
            {vm.loading && <Loader className="w-4 h-4 animate-spin" />}
            Login
        </button>

        <button
            type="button"
            onClick={() => {
                vm.setStep('forgot-password-phone');
                vm.setPhone('');
                vm.setPassword('');
                vm.setError(null);
                vm.setSuccess(null);
            }}
            className="w-full text-gray-400 hover:text-gray-300 font-semibold py-2 transition-colors"
        >
            Forgot Password?
        </button>
    </form>
);

export const ForgotPasswordPhoneStepForm = ({ vm }) => (
    <form onSubmit={vm.handleForgotPasswordOtp} className="space-y-6">
        <div>
            <label className="block text-gray-300 font-semibold mb-3">Phone Number</label>
            <div className="relative">
                <Phone className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input
                    type="tel"
                    value={vm.phone}
                    onChange={(e) => vm.setPhone(e.target.value)}
                    placeholder="9800000000"
                    className="w-full pl-12 pr-4 py-3 bg-white/10 border-2 border-white/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-500/30 backdrop-blur-sm transition-all"
                    disabled={vm.loading}
                />
            </div>
            <p className="text-gray-400 text-xs mt-2">Enter the phone number associated with your account</p>
        </div>

        <button
            type="submit"
            disabled={vm.loading || !vm.phone}
            className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white font-bold py-3 px-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-green-500/50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
            {vm.loading && <Loader className="w-4 h-4 animate-spin" />}
            Send Reset OTP
        </button>
    </form>
);

export const ForgotPasswordOtpStepForm = ({ vm }) => (
    <form onSubmit={vm.handleVerifyForgotPasswordOtp} className="space-y-6">
        <div>
            <label className="block text-gray-300 font-semibold mb-3">Enter OTP</label>
            <input
                type="text"
                value={vm.otp}
                onChange={(e) => vm.setOtp(e.target.value)}
                placeholder="Enter 4-digit OTP"
                className="w-full px-4 py-3 bg-white/10 border-2 border-white/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-500/30 backdrop-blur-sm transition-all text-center tracking-[1em] text-2xl"
                maxLength={4}
                disabled={vm.loading}
            />
        </div>

        <button
            type="submit"
            disabled={vm.loading || vm.otp.length !== 4}
            className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white font-bold py-3 px-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-green-500/50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
            {vm.loading && <Loader className="w-4 h-4 animate-spin" />}
            Verify OTP
        </button>
    </form>
);

export const SetNewPasswordStepForm = ({ vm }) => (
    <form onSubmit={vm.handleSetNewPassword} className="space-y-6">
        <div>
            <label className="block text-gray-300 font-semibold mb-3">New Password</label>
            <div className="relative">
                <input
                    type={vm.showPassword ? 'text' : 'password'}
                    value={vm.password}
                    onChange={(e) => vm.setPassword(e.target.value)}
                    placeholder="Enter new password"
                    className="w-full px-4 py-3 pr-12 bg-white/10 border-2 border-green-500/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-green-400 focus:ring-2 focus:ring-green-400/20 backdrop-blur-sm transition-all"
                    disabled={vm.loading}
                />
                <button
                    type="button"
                    onClick={() => vm.setShowPassword(!vm.showPassword)}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-300 transition-colors"
                >
                    {vm.showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
            </div>
            <p className="text-gray-400 text-xs mt-2">Password must be at least 6 characters</p>
        </div>
        <div>
            <label className="block text-gray-300 font-semibold mb-3">Confirm New Password</label>
            <div className="relative">
                <input
                    type={vm.showConfirmPassword ? 'text' : 'password'}
                    value={vm.confirmPassword}
                    onChange={(e) => vm.setConfirmPassword(e.target.value)}
                    placeholder="Confirm new password"
                    className="w-full px-4 py-3 pr-12 bg-white/10 border-2 border-green-500/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-green-400 focus:ring-2 focus:ring-green-400/20 backdrop-blur-sm transition-all"
                    disabled={vm.loading}
                />
                <button
                    type="button"
                    onClick={() => vm.setShowConfirmPassword(!vm.showConfirmPassword)}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-300 transition-colors"
                >
                    {vm.showConfirmPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
            </div>
        </div>

        <button
            type="submit"
            disabled={vm.loading || !vm.password || vm.password !== vm.confirmPassword || vm.password.length < 6}
            className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white font-bold py-3 px-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-green-500/50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
            {vm.loading && <Loader className="w-4 h-4 animate-spin" />}
            Set New Password & Login
        </button>
    </form>
);

export const OtpStepForm = ({ vm }) => (
    <form onSubmit={vm.handleVerifyOtp} className="space-y-6">
        <div>
            <label className="block text-gray-300 font-semibold mb-3">Enter OTP</label>
            <input
                type="text"
                value={vm.otp}
                onChange={(e) => vm.setOtp(e.target.value)}
                placeholder="Enter 4-digit OTP"
                className="w-full px-4 py-3 bg-white/10 border border-white/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-green-400 focus:ring-2 focus:ring-green-400/20 backdrop-blur-sm transition-all text-center tracking-[1em] text-2xl"
                maxLength={4}
                disabled={vm.loading}
            />
        </div>

        <button
            type="submit"
            disabled={vm.loading || vm.otp.length !== 4}
            className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white font-bold py-3 px-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-green-500/50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
            {vm.loading && <Loader className="w-4 h-4 animate-spin" />}
            Verify OTP
        </button>

        <div className="text-center">
            {vm.resendTimer > 0 ? (
                <p className="text-gray-400">Resend OTP in {vm.resendTimer}s</p>
            ) : (
                <button
                    type="button"
                    onClick={vm.handleResendOtp}
                    disabled={vm.loading}
                    className="text-green-400 hover:text-green-300 font-semibold transition-colors"
                >
                    Resend OTP
                </button>
            )}
        </div>
    </form>
);

export const SetPasswordAfterOtpStepForm = ({ vm }) => (
    <form onSubmit={vm.handleSetPasswordAfterOtp} className="space-y-6">
        <div className="text-center mb-6">
            <h3 className="text-xl font-bold text-white mb-2">Set Up Password</h3>
            <p className="text-gray-400 text-sm">Please set a password for future logins</p>
        </div>

        <div>
            <label className="block text-gray-300 font-semibold mb-3">Password</label>
            <div className="relative">
                <input
                    type={vm.showPassword ? 'text' : 'password'}
                    value={vm.password}
                    onChange={(e) => vm.setPassword(e.target.value)}
                    placeholder="Enter a password"
                    className="w-full px-4 py-3 pr-12 bg-white/10 border-2 border-green-500/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-green-400 focus:ring-2 focus:ring-green-400/20 backdrop-blur-sm transition-all"
                    disabled={vm.loading}
                />
                <button
                    type="button"
                    onClick={() => vm.setShowPassword(!vm.showPassword)}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-300 transition-colors"
                >
                    {vm.showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
            </div>
            <p className="text-gray-400 text-xs mt-2">Password must be at least 6 characters</p>
        </div>
        <div>
            <label className="block text-gray-300 font-semibold mb-3">Confirm Password</label>
            <div className="relative">
                <input
                    type={vm.showConfirmPassword ? 'text' : 'password'}
                    value={vm.confirmPassword}
                    onChange={(e) => vm.setConfirmPassword(e.target.value)}
                    placeholder="Confirm password"
                    className="w-full px-4 py-3 pr-12 bg-white/10 border-2 border-green-500/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-green-400 focus:ring-2 focus:ring-green-400/20 backdrop-blur-sm transition-all"
                    disabled={vm.loading}
                />
                <button
                    type="button"
                    onClick={() => vm.setShowConfirmPassword(!vm.showConfirmPassword)}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-300 transition-colors"
                >
                    {vm.showConfirmPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
            </div>
        </div>

        <button
            type="submit"
            disabled={vm.loading || !vm.password || vm.password !== vm.confirmPassword || vm.password.length < 6}
            className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white font-bold py-3 px-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-green-500/50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
            {vm.loading && <Loader className="w-4 h-4 animate-spin" />}
            Save Password & Continue
        </button>
    </form>
);

export const RegisterStepForm = ({ vm }) => (
    <form onSubmit={vm.handleRegister} className="space-y-6">
        <div>
            <label className="block text-gray-300 font-semibold mb-3">Full Name</label>
            <div className="relative">
                <User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input
                    type="text"
                    value={vm.name}
                    onChange={(e) => vm.setName(e.target.value)}
                    placeholder="Ram Bahadur"
                    className="w-full pl-12 pr-4 py-3 bg-white/10 border-2 border-orange-500/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-400/20 backdrop-blur-sm transition-all"
                    disabled={vm.loading}
                    required
                />
            </div>
        </div>

        <div>
            <label className="block text-gray-300 font-semibold mb-3">Create Password</label>
            <div className="relative">
                <input
                    type={vm.showPassword ? 'text' : 'password'}
                    value={vm.password}
                    onChange={(e) => vm.setPassword(e.target.value)}
                    placeholder="Create a password"
                    className="w-full px-4 py-3 pr-12 bg-white/10 border-2 border-orange-500/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-400/20 backdrop-blur-sm transition-all"
                    disabled={vm.loading}
                    required
                />
                <button
                    type="button"
                    onClick={() => vm.setShowPassword(!vm.showPassword)}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-300 transition-colors"
                >
                    {vm.showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
            </div>
            <p className="text-gray-400 text-xs mt-2">Password must be at least 6 characters</p>
        </div>
        <div>
            <label className="block text-gray-300 font-semibold mb-3">Confirm Password</label>
            <div className="relative">
                <input
                    type={vm.showConfirmPassword ? 'text' : 'password'}
                    value={vm.confirmPassword}
                    onChange={(e) => vm.setConfirmPassword(e.target.value)}
                    placeholder="Confirm password"
                    className="w-full px-4 py-3 pr-12 bg-white/10 border-2 border-orange-500/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-400/20 backdrop-blur-sm transition-all"
                    disabled={vm.loading}
                    required
                />
                <button
                    type="button"
                    onClick={() => vm.setShowConfirmPassword(!vm.showConfirmPassword)}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-300 transition-colors"
                >
                    {vm.showConfirmPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
            </div>
        </div>

        <button
            type="submit"
            disabled={vm.loading || !vm.name || !vm.password || vm.password !== vm.confirmPassword || vm.password.length < 6}
            className="w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-400 hover:to-orange-500 text-white font-bold py-3 px-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-orange-500/50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
            {vm.loading && <Loader className="w-4 h-4 animate-spin" />}
            Complete Registration
        </button>
    </form>
);
